<template>
    <form :class="['searchBar', { searchBar_center: center}]" :action="formAction" key="searchScreenContent" autocomplete="off">
        <div class="searchBar-hdg">
            <span class="hdg hdg_3 hdg_darkBlue">Search Kohler</span>
        </div>
        <div class="searchBar-inner">
            <div class="searchBar-inner-searchIcon">
                <i class="icon icon_search"></i>
            </div>
            <input v-model="searchTerm" type="text" class="searchBar-inner-textInput m-ellipsis" :placeholder="searchPlaceholder" ref="searchInput" @keyup="handleTextChange($event)" name="q" autocomplete="off" />
            <button type="button" class="searchBar-inner-clearIcon" @click="clearResults">
                <span class="isVisuallyHidden">Clear search field</span>
                <i :class="['icon', 'icon_closingX', theme === 'light' ? 'icon_closingX_dark' : '']"></i>
            </button>
            <div class="searchBar-inner-searchSubmit">
                <button type="submit" @click="handleSubmit">Submit</button>
            </div>
        </div>
        <div class="searchBar-inner-searchResults">
            <stagger-list :time="50">
                <li v-for="(result,index) of results" :key="result" :data-index="index">
                    <a :href="`${formAction}?q=${encodeURIComponent(result)}`" @click="handleLinkClick($event, result)">{{result}}</a>
                </li>
            </stagger-list>
        </div>
    </form>
</template>

<script>
import kohlerCorporateConfig from '../../kohlerCorporateConfig';
import autoSuggestService from '../../service/AutoSuggest';
import {getParams, applySpaces} from '../../utilities/getParams.js';
import {debounce} from '../../utilities/debounce.js';

const DEFAULT_DATA = {

};

export default {
    props: ['center', 'theme', 'ajax'],
    data() {
        // set up initial data structure for queryParamsObject
        // NOTE: this needs to be fully fleshed out so vue can cache
        // and observe correctly
        const data = {
            queryParamsObject: {
                q: '',
                filter: ''
            },
            results: [],
        };

        // copy in things from getParams()
        Object.assign(data.queryParamsObject, getParams(window.location));
        
        return data;
    },
    computed: {
        formAction: () => kohlerCorporateConfig.formActionUrl,
        searchPlaceholder: () => kohlerCorporateConfig.globalSearchPlaceholderText,
        searchTerm: {
            get() {
                return this.queryParamsObject.q;
            },
            set(value) {
                this.queryParamsObject.q = value;
            }
        }
    },
    methods: {
        handleSubmit(e) {
            // if (this.searchTerm.length < 2) {
            //     e.preventDefault();
            //     return;
            // }
            if (this.ajax) {
                e.preventDefault();
                this.$emit('new-text-search', this.searchTerm)
            }
        },
        handleLinkClick(e,result) {
            if(this.ajax) {
                e.preventDefault();
                this.$emit('new-text-search',result)

            }
        },
        handleTextChange: debounce(async function(event) {
            if (event.target.value.length) {
                let results = await autoSuggestService.getSuggestions(event.target.value, this);
                this.results = results;
            }
        }, 1000),
        clearResults() {
            this.results = [];
            this.searchTerm = '';
            this.$refs.searchInput.focus();
        }
    },

}
</script>

